<template>
   <div class="px-4 py-2 bg-primary text-center w-100">
      {{ $route.path }} — 
      {{ new Date().getFullYear() }} — 
      <strong>BECO Drive</strong>
    </div>
  </template>
